var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveRadioBtn(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 7.42857,
    stroke: "#3AB67D",
    style: (_ref2 = {
      stroke: "#3AB67D"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.2275 0.7137 0.4902)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.14286
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.00112,
    cy: 8.50112,
    r: 4.57143,
    fill: "#3AB67D",
    style: (_ref3 = {
      fill: "#3AB67D"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.2275 0.7137 0.4902)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveRadioBtn);
export default __webpack_public_path__ + "static/media/activeRadioBtn.820cb818.svg";
export { ForwardRef as ReactComponent };